/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_BehaviorInputs */

const en_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Assignment Behavior`)
};

const fr_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportement d'attribution des locuteurs`)
};

const de_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecherzuweisungsverhalten`)
};

const it_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportamento durante l'assegnazione dell'oratore`)
};

const ru_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поведение при распределении докладчиков`)
};

const es_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportamiento de asignación de oradores`)
};

const zh_cn2_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`说话人分配行为`)
};

const ja_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカー割り当ての動作`)
};

const hi_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता असाइनमेंट व्यवहार`)
};

const pt_pt2_options_editor_speaker_assignment_behavior = /** @type {(inputs: Options_Editor_Speaker_Assignment_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportamento de atribuição de locutor`)
};

/**
* | output |
* | --- |
* | "Speaker Assignment Behavior" |
*
* @param {Options_Editor_Speaker_Assignment_BehaviorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_behavior = /** @type {((inputs?: Options_Editor_Speaker_Assignment_BehaviorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_BehaviorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "de") return de_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "it") return it_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "ru") return ru_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "es") return es_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "ja") return ja_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "hi") return hi_options_editor_speaker_assignment_behavior(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_speaker_assignment_behavior(inputs)
	return en_options_editor_speaker_assignment_behavior(inputs)
});